<template>
  <label for="label" class="block text-sm my-3 font-medium text-gray-700">{{ label }} <span v-if="requires == 'True'"
      class="text-red-500 text-xs"> *</span></label>
  <div class="flex items-center">

    <label class="text-sm font-semibold text-gray-700">

      <input type="file" ref="file" class="
            file:mr-5 file:py-2 file:px-6
            file:rounded-lg file:border-blue-500 
            file:text-sm file:font-medium
            file:bg-blue-50 file:text-blue-700 
            hover:file:cursor-pointer hover:file:bg-blue-50
            hover:file:text-blue-700 " @change="handleFileUpload">

    </label>
  </div>


</template>

<script setup>

import { ref, inject } from "vue";

// define props
const props = defineProps({

  requires: {
    type: String,
    default: 'false',
  },
  label: {
    type: String,
    default: "Upload your File",
  },

});

const form = inject('form');

const buttonText = ref("Upload File");

const accept = ref("image/*");

// emit uploaded file to parent component in vue js 3
// vue js 3 emit event to parent component
const emit = defineEmits(["uploaded"]);

// get file input element
const file = ref(null);

// store uploaded file to a variable in form object
const uploadedFile = ref(null);

// handle file upload for resuable component
const handleFileUpload = (e) => {
  const file = e.target.files[0];
  uploadedFile.value = file;
  form.file = file;
  form.fileName = file.name;
  emit("uploaded", file);
};



</script>